import app from 'flarum/forum/app';

import config from '../common/config';
import addExtraHero from './addExtraHero';

app.initializers.add(config.module.key, () => {
  addExtraHero();
});
